export class ChallengesRoutingNames {
    public static readonly NAME_BASE = '';
    public static readonly NAME_CHALLENGE = 'challenge';

    public static readonly ROUTE_BASE = `/${ChallengesRoutingNames.NAME_BASE}`;
    public static readonly ROUTE_CHALLENGE = `/${ChallengesRoutingNames.NAME_CHALLENGE}`;
}
